// Module
var code = `<div class="rounded-xs relative shadow-none bg-gray-50 {{ cardClass }}"> <div class="p-6 {{ contentClass }}"> <section-heading ng-if="headline || prompt" headline="{{ headline }}" description="{{ prompt }}"></section-heading> <ng-transclude class="{{ transclusionClass }}"></ng-transclude> </div> </div> `;
// Exports
export default code;